import React from 'react';
import { Box } from '@mui/material';
import { ActivityProps } from '../../../types/ActivityHistoryTypes';
import { ActivityTimelineItem } from './ActivityTimelineItem';

export type ActivityTimelineProps = {
    activities: ActivityProps[];
    onEditNote?: (
        noteId: string,
        content: string,
        highlighted: boolean,
        memoClient: boolean,
    ) => void;
    onDeleteNote?: (noteId: string) => void;
};

export const ActivityTimeline: React.FunctionComponent<ActivityTimelineProps> = function ({
    activities,
    onEditNote,
    onDeleteNote,
}) {
    const sortedActivities = React.useMemo(
        () => [...activities].sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()),
        [activities],
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {sortedActivities.map((activity, index) => (
                <ActivityTimelineItem
                    key={activity.id}
                    activity={activity}
                    isLast={index === sortedActivities.length - 1}
                    onEditNote={onEditNote}
                    onDeleteNote={onDeleteNote}
                />
            ))}
        </Box>
    );
};
